/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
    // Локальные переменные
    const module = this;

    const Settings = {
        global: {
            slidesPerView: "auto",
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderName = swiperContainer.getAttribute("data-slider-name");

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            }
        },
        remedies: {
            slidesPerView: 'auto',
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderName = swiperContainer.getAttribute("data-slider-name");

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            }
        },
        advantages: {
            slidesPerView: 'auto',
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderName = swiperContainer.getAttribute("data-slider-name");

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            }
        },
        articles: {
            slidesPerView: 'auto',
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderName = swiperContainer.getAttribute("data-slider-name");

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            }
        },
        byuing: {
            slidesPerView: 'auto',
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderName = swiperContainer.getAttribute("data-slider-name");

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            }
        },
        componentsGel: {
            slidesPerView: 'auto',
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderName = swiperContainer.getAttribute("data-slider-name");

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            }
        },
        power: {
            slidesPerView: 'auto',
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderName = swiperContainer.getAttribute("data-slider-name");

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            }
        },
        test: {
            slidesPerView: 1,
            simulateTouch: false,
            keyboard: {
                enabled: false,
                onlyInViewport: false
            },
            followFinger: false,
            watchOverflow: true,
            autoHeight: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            spaceBetween: 16,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderName = swiperContainer.getAttribute("data-slider-name");

                    const testBlockEl = document.querySelector('#imt');

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                        Swiper.initedSliders[sliderName].customCheckedToggles = [];
                    }

                    const actualTestToggleEls = testBlockEl.querySelectorAll(".js-test-toggle");
                    const checkedToggles = Array.prototype.filter.call(actualTestToggleEls, item => item.checked);
                    Swiper.initedSliders["test"].customCheckedToggles = checkedToggles;

                    const slider = swiperContainer.closest('.js-slider');
                    const stepNumberEl = slider.querySelector(".js-step-number");
                    const allStepsNumberEl = slider.querySelector(".js-all-steps-number");
                    const inputNumberEls = testBlockEl.querySelectorAll("[data-number]");
                    // Swiper.initedSliders["test"].removeSlide(2);//
                    stepNumberEl.textContent = swiper.activeIndex + 1;
                    allStepsNumberEl.textContent = swiper.slides.length;

                    swiper.params.custom = {
                        testBlockEl: testBlockEl,
                        nextBtn: testBlockEl.querySelector(".js-next-btn"),
                        inputs: testBlockEl.querySelectorAll(".js-test-input"),
                        toggleSetEls: testBlockEl.querySelectorAll(".js-toggle-set"),
                        checkedToggles: checkedToggles
                    }

                    if (swiper.params.custom.checkedToggles.length != swiper.params.custom.toggleSetEls.length) {
                        swiper.allowSlideNext = false;

                        setTimeout(function () {
                            swiper.params.custom.nextBtn.disabled = true;
                        }, 500);
                    } else {
                        swiper.allowSlideNext = true;

                        setTimeout(function () {
                            swiper.params.custom.nextBtn.disabled = false;
                        }, 500);
                    }

                    if (inputNumberEls.length > 0) {
                        Array.prototype.forEach.call(inputNumberEls, function (inputNumber) {
                            inputNumber.addEventListener("keydown", function (evt) {
                                if ((evt.keyCode < 48 || evt.keyCode > 57) && (evt.keyCode < 37 || evt.keyCode > 40) && evt.keyCode !== 8 && evt.keyCode !== 46 && evt.keyCode !== 48 && evt.keyCode !== 57 && evt.keyCode !== 109 && evt.keyCode !== 107 && (evt.keyCode < 96 || evt.keyCode > 105)) {
                                    evt.preventDefault();
                                }
                            });
                        });
                    }
                },

                slideChange: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const testStepEls = swiper.params.custom.testBlockEl.querySelectorAll(".js-step-block");
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    const conditionButtonEl = slider.querySelector(".js-condition");
                    const submitButtonEl = slider.querySelector(".js-submit");
                    const stepNumberEl = slider.querySelector(".js-step-number");
                    stepNumberEl.textContent = swiper.activeIndex + 1;
                    const checkedToggles = Swiper.initedSliders[sliderName].customCheckedToggles;

                    const activeItem = testStepEls[Swiper.initedSliders["test"].activeIndex];
                    const activeInput = activeItem && activeItem.querySelector(".js-test-input");
                    const activeValue = activeInput && !!activeInput.value;

                    if (activeInput && !activeInput.value) {
                        swiper.allowSlideNext = false;
                        swiper.params.custom.nextBtn.disabled = true;
                    } else if (!activeInput && swiper.params.custom.checkedToggles.length != swiper.params.custom.toggleSetEls.length) {
                        swiper.allowSlideNext = false;
                        swiper.params.custom.nextBtn.disabled = true;
                    } else {
                        swiper.allowSlideNext = true;
                        swiper.params.custom.nextBtn.disabled = false;
                    }

                    if (swiper.params.custom.checkedToggles.length == swiper.params.custom.toggleSetEls.length && swiper.activeIndex + 1 == swiper.slides.length && ((activeInput && activeInput.value) || !activeInput)) {
                        conditionButtonEl.classList.add("js-hide");
                        submitButtonEl.classList.remove("js-hide");
                    } else {
                        conditionButtonEl.classList.remove("js-hide");
                        submitButtonEl.classList.add("js-hide");
                    }
                },

                slidesLengthChange: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const allStepsNumberEl = slider.querySelector(".js-all-steps-number");
                    allStepsNumberEl.textContent = swiper.slides.length;
                }
            },

            breakpoints: {
                768: {
                    spaceBetween: 8
                }
            }
        },

        testExtra: {
            slidesPerView: 1,
            simulateTouch: false,
            keyboard: {
                enabled: false,
                onlyInViewport: false
            },
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            followFinger: false,
            watchOverflow: true,
            autoHeight: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            spaceBetween: 64,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderName = swiperContainer.getAttribute("data-slider-name");

                    const testBlockEl = document.querySelector('#test');
                    const sliderTarget = document.querySelector(".js-slider-target");

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                        Swiper.initedSliders[sliderName].customCheckedToggles = [];
                    }

                    const actualTestToggleEls = testBlockEl.querySelectorAll(".js-test-toggle");
                    const checkedToggles = Array.prototype.filter.call(actualTestToggleEls, item => item.checked);
                    Swiper.initedSliders["test"].customCheckedToggles = checkedToggles;

                    const slider = swiperContainer.closest('.js-slider');
                    const stepNumberEl = slider.querySelector(".js-step-number");
                    const allStepsNumberEl = slider.querySelector(".js-all-steps-number");
                    const inputNumberEls = testBlockEl.querySelectorAll("[data-number]");
                    // Swiper.initedSliders["test"].removeSlide(2);//
                    stepNumberEl.textContent = swiper.activeIndex + 1;
                    allStepsNumberEl.textContent = swiper.slides.length;

                    swiper.params.custom = {
                        testBlockEl: testBlockEl,
                        nextBtn: testBlockEl.querySelector(".js-next-btn"),
                        inputs: testBlockEl.querySelectorAll(".js-test-input"),
                        toggleSetEls: testBlockEl.querySelectorAll(".js-toggle-set"),
                        checkedToggles: checkedToggles,
                        requested: false
                    }

                    if (swiper.params.custom.checkedToggles.length != swiper.params.custom.toggleSetEls.length) {
                        swiper.allowSlideNext = false;

                        setTimeout(function () {
                            swiper.params.custom.nextBtn.disabled = true;
                        }, 500);
                    } else {
                        swiper.allowSlideNext = true;

                        setTimeout(function () {
                            swiper.params.custom.nextBtn.disabled = false;
                        }, 500);
                    }

                    if (inputNumberEls.length > 0) {
                        Array.prototype.forEach.call(inputNumberEls, function (inputNumber) {
                            inputNumber.addEventListener("keydown", function (evt) {
                                if ((evt.keyCode < 48 || evt.keyCode > 57) && (evt.keyCode < 37 || evt.keyCode > 40) && evt.keyCode !== 8 && evt.keyCode !== 46 && evt.keyCode !== 48 && evt.keyCode !== 57 && evt.keyCode !== 109 && evt.keyCode !== 107 && (evt.keyCode < 96 || evt.keyCode > 105)) {
                                    evt.preventDefault();
                                }
                            });
                        });
                    }

                    sliderTarget.classList.remove("js-disabled");
                },

                slideChange: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const testStepEls = swiper.params.custom.testBlockEl.querySelectorAll(".js-step-block");
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    const conditionButtonEl = slider.querySelector(".js-condition");
                    const submitButtonEl = slider.querySelector(".js-submit");
                    const stepNumberEl = slider.querySelector(".js-step-number");
                    stepNumberEl.textContent = swiper.activeIndex + 1;
                    const checkedToggles = Swiper.initedSliders[sliderName].customCheckedToggles;

                    const activeItem = testStepEls[Swiper.initedSliders["test"].activeIndex];
                    const activeInput = activeItem && activeItem.querySelector(".js-test-input");
                    const activeValue = activeInput && !!activeInput.value;

                    // if (activeInput && !activeInput.value) {
                    //     swiper.allowSlideNext = false;
                    //     swiper.params.custom.nextBtn.disabled = true;
                    // } else if (!activeInput && swiper.params.custom.checkedToggles.length != swiper.params.custom.toggleSetEls.length) {
                    //     swiper.allowSlideNext = false;
                    //     swiper.params.custom.nextBtn.disabled = true;
                    // } else {
                    //     swiper.allowSlideNext = true;
                    //     swiper.params.custom.nextBtn.disabled = false;
                    // }

                    if (Swiper.initedSliders["test"].params.custom.checkedToggles.length < Swiper.initedSliders["test"].activeIndex + 1 && Swiper.initedSliders["test"].params.custom.checkedToggles.length != Swiper.initedSliders["test"].slides.length) {
                        swiper.allowSlideNext = false;
                        swiper.params.custom.nextBtn.disabled = true;
                    } else {
                        swiper.allowSlideNext = true;
                        swiper.params.custom.nextBtn.disabled = false;
                    }

                    if (swiper.params.custom.checkedToggles.length == swiper.params.custom.toggleSetEls.length && swiper.activeIndex + 1 == swiper.slides.length) {
                        if (!Swiper.initedSliders["test"].params.custom.requested) {
                            Swiper.initedSliders["test"].params.custom.requested = true;
                            conditionButtonEl.classList.add("js-hide");
                            submitButtonEl.classList.remove("js-hide");
                            swiper.params.custom.createRequest();
                        }
                    } else {
                        conditionButtonEl.classList.remove("js-hide");
                        submitButtonEl.classList.add("js-hide");
                    }
                },

                slidesLengthChange: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const allStepsNumberEl = slider.querySelector(".js-all-steps-number");
                    allStepsNumberEl.textContent = swiper.slides.length;
                }
            },

            breakpoints: {
                768: {
                    spaceBetween: 1000
                }
            }
        },
    };

    const getSettings = function (slidersSettingsKey) {
        return Settings[slidersSettingsKey];
    };

    module.getSettings = getSettings;
});